import React from "react";
import { useModal } from "../modal/modal.context";
import { imagePlaceholder } from "../../../constants/image-static";
import { useConverter } from "../../hook/currency-conversion";
  
  type ProductListProps = {
    products:any[]
  }
  export default function ProductList({ products = [] }: ProductListProps) {
    const { openModal } = useModal();
    const { UiForex, currency_name } = useConverter();
  
    return (
      <div className="bg-white">
        <div className="max-w-2xl mx-auto py-16 px-4 sm:py-24 sm:px-6 lg:max-w-7xl lg:px-8">
          {/* <h2 className="text-2xl font-extrabold tracking-tight text-gray-900">Customers also purchased</h2> */}
  
          <div className="mt-6 grid grid-cols-1 gap-y-10 gap-x-6 sm:grid-cols-2 lg:grid-cols-4 xl:gap-x-8">
            {products.map((product) => (
              <div key={product.id} 
                className="group relative"
                onClick={()=>openModal({ view:"VIEW_PRODUCT", payload: product })}
              >
                <div className="w-full min-h-80 bg-gray-200 aspect-w-1 aspect-h-1 rounded-md overflow-hidden group-hover:opacity-75 lg:h-80 lg:aspect-none">
                  <img
                    src={product.image[0]?.image ?? imagePlaceholder}
                    alt="product"
                    className="w-full h-full object-center object-cover lg:w-full lg:h-full"
                  />
                </div>
                <div className="mt-4 flex justify-between">
                  <div>
                    <h3 className="text-sm text-gray-700">
                      <a href={product.href}>
                        <span aria-hidden="true" className="absolute inset-0" />
                        {product.name}
                      </a>
                    </h3>
                    {product.price !== 0 && <UiForex from={currency_name} value={product.price} styli="mt-1 text-sm text-gray-500 line-through"/>}
                  </div>
                  <p className="text-sm font-medium text-gray-900">{product.sale_price_fx}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    )
  }
  